"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./OptionChainMiddleTable.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const OptionChainMiddleTable = ({
  strikes = [],
  spotPrice = '--',
  spots = [],
  showLegend,
  callContainerWidth,
  middleContainerWidth,
  middleContainerRef
}) => (0, _pragma.createFelaElement)(_.Table, {
  css: css.strikeTable,
  variant: "strike",
  ref: middleContainerRef
}, (0, _pragma.createFelaElement)(_.TableHead, null, (0, _pragma.createFelaElement)(_.TableRow, {
  padding: ['medium', 'xsmall'],
  css: css.strikeHeader
}, (0, _pragma.createFelaElement)(_.TableCell, {
  align: "center",
  variant: "strike"
}, (0, _pragma.createFelaElement)(_.Text, {
  children: "Strike Price",
  color: "text.1",
  variant: "metaBold"
}))), (0, _pragma.createFelaElement)(_.TableRow, {
  css: css.strikeScrollTableRow
}, (0, _pragma.createFelaElement)(_.TableCell, null)), showLegend && (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.TableRow, {
  css: css.hiddenRow
}, (0, _pragma.createFelaElement)(_.TableCell, {
  css: css.hiddenCell
}, (0, _pragma.createFelaElement)(_.View, {
  css: css.legendRow,
  cssProps: {
    callContainerWidth,
    middleContainerWidth
  },
  justifyContent: "space-between",
  alignItems: "center",
  padding: "xsmall"
}, (0, _pragma.createFelaElement)(_.MiniHorizontalBarChart, {
  labelBottom: "Yesterday",
  labelTop: "Today",
  variant: "positive"
}), (0, _pragma.createFelaElement)(_.View, {
  gap: "xsmall"
}, (0, _pragma.createFelaElement)("div", {
  css: css.legendColorIndicator
}), (0, _pragma.createFelaElement)(_.Text, {
  children: "In the money",
  color: "text.1",
  variant: "meta"
})), (0, _pragma.createFelaElement)(_.MiniHorizontalBarChart, {
  labelBottom: "Yesterday",
  labelTop: "Today",
  variant: "negative"
})))), (0, _pragma.createFelaElement)(_.TableRow, {
  css: css.legendRowUnderneath
}, (0, _pragma.createFelaElement)(_.TableCell, {
  padding: 0
})))), (0, _pragma.createFelaElement)(_.TableBody, {
  css: css.tableBody
}, strikes.map((row, i) => // eslint-disable-next-line react/no-array-index-key
(0, _pragma.createFelaElement)(_.TableRow, {
  key: i,
  padding: ['small', 'xsmall']
}, (0, _pragma.createFelaElement)(_.TableCell, {
  align: "center",
  css: css.strikeCell
}, (0, _pragma.createFelaElement)(_.Text, {
  children: row,
  color: "text.1",
  variant: "meta"
})))), (0, _pragma.createFelaElement)(_.TableRow, {
  css: css.spotTableRow,
  cssProps: {
    callContainerWidth,
    middleContainerWidth
  }
}, (0, _pragma.createFelaElement)(_.TableCell, {
  align: "center",
  css: css.spotTableCell
}, (0, _pragma.createFelaElement)(_.Text, {
  color: "text.1",
  variant: "metaBold",
  css: css.spotText
}, 'Spot Price: ', spotPrice))), (0, _pragma.createFelaElement)(_.TableRow, null, (0, _pragma.createFelaElement)(_.TableCell, {
  align: "center",
  css: css.spotTableCell
})), spots.map((row, i) => // eslint-disable-next-line react/no-array-index-key
(0, _pragma.createFelaElement)(_.TableRow, {
  key: i,
  padding: ['small', 'xsmall']
}, (0, _pragma.createFelaElement)(_.TableCell, {
  align: "center",
  css: css.strikeCell
}, (0, _pragma.createFelaElement)(_.Text, {
  children: row,
  color: "text.1",
  variant: "meta"
}))))));

OptionChainMiddleTable.displayName = 'OptionChainMiddleTable';
var _default = OptionChainMiddleTable;
exports.default = _default;
//# sourceMappingURL=OptionChainMiddleTable.js.map